import React, { useEffect, useState } from "react";
import withAuth from "../../hocs/withAuth";
import { Box, Grid2, Skeleton, Typography } from "@mui/material";
import { HEADER_HEIGHT } from "../../utils/ui.constants";
import { asyncSearchList } from "../../utils/httpRequests";
import { useDispatch, useSelector } from "react-redux";
import { useAlertContext } from "../../contexts/alert/AlertProvider";
import { isArray } from "lodash";
import { updateApp } from "../../redux/reducers/app.reducer";
import { useNavigate } from "react-router-dom";
import BasicLayout from "../../components/common/layout/basic/BasicLayout";
import { resetPos } from "../../redux/reducers/pos.reducer";
import { resetFnb } from "../../redux/reducers/fnb.reducer";
import { resetKitchen } from "../../redux/reducers/kitchen.reducer";
import { resetRestaurant } from "../../redux/reducers/restaurant.reducer";

function AppPage() {
  const { showAlert } = useAlertContext();
  const token = useSelector((state: any) => state.auth.token);
  const currentApp = useSelector((state: any) => state.app.data);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSelectApp = (app: any) => {
    dispatch(updateApp(app));
    dispatch(resetPos());
    dispatch(resetFnb());
    dispatch(resetKitchen());
    dispatch(resetRestaurant());
    navigate(-1);
  };

  const getApps = async () => {
    if (loading) return;
    setLoading(true);
    const condition = { page: 1, limit: 999999 };
    const resp = await asyncSearchList({
      apiCode: "app",
      applyToken: true,
      token,
      withIdApp: false,
      condition,
    });
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message: resp?.data?.message || resp?.data?.error,
      });
    } else {
      setData(resp.data || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    getApps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <BasicLayout>
        <Box
          sx={{
            minHeight: `calc(100vh - ${HEADER_HEIGHT})`,
            backgroundColor: "divider",
            px: 2,
            py: 2,
          }}
        >
          <Grid2 container spacing={2}>
            {loading ? (
              <>
                {new Array(4).fill(0).map((_, index) => {
                  return (
                    <Grid2 key={index} size={{ xs: 6, md: 3 }}>
                      <Skeleton
                        variant="rounded"
                        animation="wave"
                        sx={{ width: "100%", height: "200px" }}
                      />
                    </Grid2>
                  );
                })}
              </>
            ) : (
              <>
                {isArray(data) &&
                  data.map((item) => {
                    return (
                      <Grid2 key={item._id} size={{ xs: 12, sm: 6, md: 3 }}>
                        <Box
                          onClick={() => handleSelectApp(item)}
                          sx={{
                            height: "100%",
                            p: 2,
                            borderRadius: "10px",
                            backgroundColor: "background.paper",
                            border: "1px solid",
                            borderColor:
                              currentApp?._id === item._id
                                ? "primary.main"
                                : "transparent",
                            cursor: "pointer",
                          }}
                        >
                          <Typography sx={{ fontWeight: 500, mb: 1 }}>
                            {item.name}
                          </Typography>
                          <Typography>Địa chỉ: {item?.address}</Typography>
                        </Box>
                      </Grid2>
                    );
                  })}
              </>
            )}
          </Grid2>
        </Box>
      </BasicLayout>
    </>
  );
}

export default withAuth(AppPage);
